const zwds = {
  zwds: {
    // Palace names
    palaces: {
      命宫: "Life",
      兄弟: "Siblings",
      夫妻: "Spouse",
      子女: "Children",
      财帛: "Wealth",
      疾厄: "Health",
      迁移: "Travel",
      交友: "Friends",
      官禄: "Career",
      田宅: "Property",
      福德: "Wellbeing",
      父母: "Parents",
    },

    // Heavenly Stems
    stems: {
      甲: "Jia",
      乙: "Yi",
      丙: "Bing",
      丁: "Ding",
      戊: "Wu",
      己: "Ji",
      庚: "Geng",
      辛: "Xin",
      壬: "Ren",
      癸: "Gui",
    },

    // Earthly Branches
    branches: {
      子: "Zi",
      丑: "Chou",
      寅: "Yin",
      卯: "Mao",
      辰: "Chen",
      巳: "Si",
      午: "Wu",
      未: "Wei",
      申: "Shen",
      酉: "You",
      戌: "Xu",
      亥: "Hai",
    },

    monthBranches:{
      子: "1",
      丑: "2",
      寅: "3",
      卯: "4",
      辰: "5",
      巳: "6",
      午: "7",
      未: "8",
      申: "9",
      酉: "10",
      戌: "11",
      亥: "12",
    },

    dayBranches:{
      子: "1",
      丑: "3",
      寅: "5",
      卯: "7",
      辰: "9",
      巳: "11",
      午: "13",
      未: "15",
      申: "17",
      酉: "19",
      戌: "21",
      亥: "23",
    },
    // Main stars
    mainStars: {
      紫微: "Zi Wei",
      天机: "Tian Ji",
      天機: "Tian Ji",
      太阳: "Tai Yang",
      太陽: "Tai Yang",
      武曲: "Wu Qu",
      天同: "Tian Tong",
      廉贞: "Lian Zhen",
      廉貞: "Lian Zhen",
      天府: "Tian Fu",
      太阴: "Tai Yin",
      太陰: "Tai Yin",
      贪狼: "Tan Lang",
      貪狼: "Tan Lang",
      巨门: "Ju Men",
      巨門: "Ju Men",
      天相: "Tian Xiang",
      天梁: "Tian Liang",
      七杀: "Qi Sha",
      七殺: "Qi Sha",
      破军: "Po Jun",
      破軍: "Po Jun",
    },

    // Transformations
    transformations: {
      化科: "Ke",
      化权: "Quan",
      化權: "Quan",
      化禄: "Lu",
      化祿: "Lu",
      化忌: "Ji",
    },

    // Minor stars
    minorStars: {
      文昌: "Wen Chang",
      文曲: "Wen Qu",
      左辅: "Zuo Fu",
      左輔: "Zuo Fu",
      右弼: "You Bi",
      天魁: "Tian Kui",
      天钺: "Tian Yue",
      天厨: "Tian Chu",
      天廚: "Tian Chu",
      天刑: "Tian Xing",
      天姚: "Tian Yao",
      天喜: "Tian Xi",
      地空: "Di Kong",
      地劫: "Di Jie",
      火星: "Huo Xing",
      铃星: "Ling Xing",
      鈴星: "Ling Xing",
    },

    // Five Elements
    fiveElements: {
      水二局: "Water Element (2)",
      木三局: "Wood Element (3)",
      金四局: "Metal Element (4)",
      土五局: "Earth Element (5)",
      火六局: "Fire Element (6)",
    },

    // Chart sections
    chart: {
      年: "Year",
      月: "Month",
      日: "Day",
      时: "Hour",
      生肖: "Chinese Zodiac",
      五行: "Five Elements",
      阳历: "Solar Calendar",
      阴历: "Lunar Calendar",
      男: "Male",
      女: "Female",
      命主: "Life Master",
      身主: "Body Master",
      大限: "Major Limit",
      小限: "Minor Limit",
      流年: "Annual Flow",
      age: "Age",
      westernZodiac: "Western Zodiac",
    },

    lunarDays:{
      初一: "1",
      初二: "2",
      初三: "3",
      初四: "4",
      初五: "5",
      初六: "6",
      初七: "7",
      初八: "8",
      初九: "9",
      初十: "10",
      十一: "11",
      十二: "12",
      十三: "13",
      十四: "14",
      十五: "15",
      十六: "16",
      十七: "17",
      十八: "18",
      十九: "19",
      二十: "20",
      廿一: "21",
      廿二: "22",
      廿三: "23",
      廿四: "24",
      廿五: "25",
      廿六: "26",
      廿七: "27",
      廿八: "28",
      廿九: "29",
      三十: "30",
      三十一: "31",
    },

    zodiac:{
      rat: "Rat",
      ox: "Ox",
      tiger: "Tiger",
      rabbit: "Rabbit",
      dragon: "Dragon",
      snake: "Snake",
      horse: "Horse",
      sheep: "Sheep",
      monkey: "Monkey",
      rooster: "Rooster",
      dog: "Dog",
      pig: "Pig",
    
    },
    westernZodiac:{
      aries: "Aries",
      taurus: "Taurus",
      gemini: "Gemini",
      cancer: "Cancer",
      leo: "Leo",
      virgo: "Virgo",
      libra: "Libra",
      scorpio: "Scorpio",
      sagittarius: "Sagittarius",
      capricorn: "Capricorn",
      aquarius: "Aquarius",
      pisces: "Pisces",
    }
  },
};

export default zwds;
